import React, { useState, useCallback, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import logo from '../../assets/logo/logo.png'; // Tell webpack this JS file uses this image
import { makeStyles } from '@material-ui/core/styles';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import LockIcon from '@material-ui/icons/Lock';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import HomeStyles from '../../styles/Home.module.css'
import axios from 'axios';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { InputAdornment, Typography } from "@material-ui/core"
import useToken from '../auth/useToken';
import { useDispatch, useSelector } from "react-redux";
import { getAgentProfile } from "../../redux/modules/profileSlice";
import api from '../../libs/utils/axiosApiInstance'
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Visibility from '@material-ui/icons/Visibility';

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        paddingLeft: 100,
        paddingRight: 100,
        // paddingTop: 25,
        // paddingButton: 25,
        flex: 1,
    },
    customInput: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 'auto',
    },
    margin: {
        marginTop: '15px',
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    button: {
        // marginRight: theme.spacing(2),
        background: '#FDB738',
        "&:hover": {
            background: '#f9a100',
        },
        color: '#FFFFFF',
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    buttonLogin: {
        background: '#3364AF',
        width: '150px',
        height: '50px'
    },
    buttonSubmit: {
        background: '#3364AF',
        width: '100px'
    },
    buttonBack: {

        width: '100px'
    },
    labelCheckbox: {
        fontSize: '10px'
    },
    font1: { "fontFamily": "Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif", "fontWeight": "bold", "color": "#3364af", "fontSize": "2.6rem" },
    font2: { "fontFamily": "Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif", "fontWeight": "bold", "color": "#8faadc", "fontSize": "2.6rem" }

}));


const responseCode = [
    {
        code: 1001,
        name: "ไม่พบชื่อผู้ใช้งานนี้ในระบบ"
    },
    {
        code: 1002,
        name: "ไม่พบอีเมลนี้ในระบบ"
    },
    {
        code: 1003,
        name: "รหัสผ่านไม่ถูกต้อง"
    },
    {
        code: 1004,
        name: "มีผู้ใช้นี้กำลังใช้งาน"
    }
]

export default function ConFirmLoginDialog(props) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const { token, setToken } = useToken();
    const [checkLogin, setCheckLogin] = useState(false);

    const handleOnLink = useCallback(() => history.push('/Profile'), [history]);
    const [spinner, setSpinner] = useState(null);
    const [errMessage, setErrMessage] = useState('');
    const [loginRes, setLoginRes] = useState(null);
    const [profile, setProfile] = useState(null);
    const [agentsList, setAgentList] = useState([]);
    const { onClose, openPopup, setOpenPopup, email, earlyToken } = props;
    let [input, setInput] = useState({
        usernameOrEmail: '',
        password: '',
        confirmPassword: '',
    });
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    useEffect(() => {
        setInput({
            ...input,
            usernameOrEmail: email
        })
    }, [email])
    const onBack = () => {
        setLoginRes(null);
        setAgentList([]);
        setProfile(null);
        setErrMessage('');
    }


    const handleChange = e => {

        const { target } = e;
        const { name } = target;

        const value = name === 'term' ? target.checked : target.value;
        setInput({
            ...input,
            [name]: value

        });


    }

    const selectedAgent = agent => {
        // console.log(agent);
        if (agent) {
            setProfile(agent);
        }
    }





    const handleClose = () => {
        // setInput({
        //     usernameOrEmail: '',
        //     password: '',
        // });
        setAgentList([]);
        setErrMessage('');
        setProfile(null);
        // onClose(false);
        setSpinner(false)

    };

    const handleLoginSuccess = () => {
        setInput({
            usernameOrEmail: '',
            password: '',
        });

        setErrMessage('');
        // onClose(true);
    };

    const onSubmit = async e => {
        e.preventDefault()


        if (!input.password || !input.usernameOrEmail) {
            const message = 'กรุณากรอก Email และ Password';
            setErrMessage(message);
            return;
        }
        if (input.password !== input.confirmPassword) {
            const message = 'กรุณากรอก รหัสผ่าน และ ยืนยันรหัสผ่าน ให้ตรงกัน';
            setErrMessage(message);
            return;
        }
        const body = {
            Password: input.password
        };
        setSpinner(true)
        // const res = await api.post(`/auth/login`, body);

        // if (res.data.result) {
        //     const _loginRes = res.data.result;
        //     setLoginRes(_loginRes);
        const res = await api.put(`/profile/user`, body, { headers: { "Authorization": `Bearer ${earlyToken.AccessToken}` } });

        if (res.data.status) {
            const profile = await api.get(`/profile/agents`, { headers: { "Authorization": `Bearer ${earlyToken.AccessToken}` } });

            const _agentList = profile?.data?.result;

            if (_agentList.length > 0) {
                if (_agentList.length > 1) {
                    setAgentList(_agentList)
                    setCheckLogin(true)
                } else {
                    localStorage.setItem('token', earlyToken.AccessToken);
                    localStorage.setItem('refreshToken', earlyToken.RefreshToken);
                    localStorage.setItem('refreshExpired', earlyToken.ExpireDate);
                    localStorage.setItem('requestNo', _agentList[_agentList.length - 1].RequestNo);

                    await dispatch(getAgentProfile())
                    // history.push('/profile');
                    window.location.href = '/profile'

                    setErrMessage('');
                    handleLoginSuccess()
                    handleOnLink();
                    setLoginRes(null);
                    setAgentList([]);
                    setProfile(null);
                }
            } else {
                setCheckLogin(true)
            }
            setErrMessage('');


        } else {

        }


        // } else {
        //     const message = res.data.code;
        //     const findMessage = responseCode.find(x => x.code === message);
        //     setErrMessage(findMessage.name);
        // }
        setSpinner(false)
    }


    const onSave = async (profile) => {
        if (!profile) {
            setErrMessage('กรุณาเลือกตัวแทนจำหน่าย');
            return;
        }
        setSpinner(true)
        localStorage.setItem('token', earlyToken.AccessToken);
        localStorage.setItem('refreshToken', earlyToken.RefreshToken);
        localStorage.setItem('refreshExpired', earlyToken.ExpireDate);
        localStorage.setItem('requestNo', profile.RequestNo);

        await dispatch(getAgentProfile())
        // history.push('/profile');
        // window.location.href = '/profile'

        setErrMessage('');
        handleLoginSuccess()
        handleOnLink();
        setLoginRes(null);
        setAgentList([]);
        setProfile(null);
        setSpinner(false)
    }


    return (

        <Dialog maxWidth="sm" fullWidth
            // onClose={handleClose}
            open={openPopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >

            <DialogTitle id="alert-dialog-title" >
                <div className="text-center pt-3 pb-3">
                    <div style={{
                        width: '100%',
                        display: "flex",
                        justifyContent: 'center'
                    }}>
                        <img className="img-fluid me-2" style={{
                            background: 'transparent',
                            width: "100px", height: '100px'
                        }} src='/Rice-Dept_Copy.png' alt="logo"></img>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: 'flex-start' }}>
                            <div>
                                <label className={classes.font1}>S</label><label className={classes.font2}> mart</label>&nbsp;&nbsp;<label className={classes.font1}>S</label><label className={classes.font2}> eed</label>&nbsp;&nbsp;<label className={classes.font1}>S</label><label className={classes.font2}> tock</label>&nbsp;&nbsp;<label className={classes.font1}>S</label><label className={classes.font2}> ystem</label>
                            </div>
                            <label style={{
                                color: '#af890e',
                                fontWeight: 'bold',
                                fontSize: '1.5rem',

                            }}>ระบบการผลิตและการกระจายเมล็ดพันธุ์ข้าว</label>

                        </div>
                    </div>

                </div>

            </DialogTitle>
            {agentsList.length === 0 && !checkLogin &&
                <>
                    <form className={classes.root} autoComplete="off">

                        <Paper elevation={3} className={classes.customInput}>
                            <IconButton className={classes.iconButton} aria-label="menu">
                                <MailOutlineIcon />
                            </IconButton>
                            <InputBase value={input.usernameOrEmail} onChange={handleChange} required error={true}
                                className={classes.input}
                                placeholder="Email"
                                id="usernameOrEmail"
                                name="usernameOrEmail"
                            />

                        </Paper>


                        <Paper elevation={3} className={classes.customInput} style={{
                            marginTop: '20px',
                        }}>
                            <IconButton className={classes.iconButton} aria-label="menu">
                                <LockIcon />
                            </IconButton>
                            <InputBase onChange={handleChange} required error={true}
                                className={classes.input}
                                placeholder="รหัสผ่าน"
                                label="password"
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                name="password"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton style={{ marginRight: '0px' }}
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />

                        </Paper>

                        {errMessage ?
                            <Typography style={{
                                fontSize: '14px',
                                marginTop: '7px',
                                color: 'red'
                            }}>
                                {errMessage}
                            </Typography> : ''
                        }
                        <Paper elevation={3} className={classes.customInput} style={{
                            marginTop: '20px',
                        }}>
                            <IconButton className={classes.iconButton} aria-label="menu">
                                <LockIcon />
                            </IconButton>
                            <InputBase onChange={handleChange} required error={true}
                                className={classes.input}
                                placeholder="ยืนยันรหัสผ่าน"
                                label="confirmPassword"
                                type={showPassword ? 'text' : 'password'}
                                id="confirmPassword"
                                name="confirmPassword"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton style={{ marginRight: '0px' }}
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />

                        </Paper>

                        {errMessage ?
                            <Typography style={{
                                fontSize: '14px',
                                marginTop: '7px',
                                color: 'red'
                            }}>
                                {errMessage}
                            </Typography> : ''
                        }

                    </form>



                    <DialogActions style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '20px',
                        marginBottom: '20px'

                    }}>
                        <Button variant="contained" type="submit" onClick={onSubmit} className={classes.buttonLogin} color="primary"
                        >
                            {spinner ?
                                <div className="spinner-border" role="status"    >
                                    <span className="sr-only"></span>
                                </div>
                                : ('เข้าสู่ระบบ')

                            }


                        </Button>
                    </DialogActions>
                </>
            }


            {(agentsList.length > 0) &&
                <DialogTitle id="alert-dialog-title" style={{
                    color: 'gray',
                    padding: '0'
                }}>
                    <div className="text-center pb-3">
                        รายการตัวแทนจำหน่าย
                    </div>

                </DialogTitle>
            }
            {checkLogin && agentsList.length === 0 &&
                <DialogTitle id="alert-dialog-title" style={{
                    padding: '0'
                }}>
                    <div className="text-center pb-3">
                        ไม่พบรายการตัวแทนจำหน่าย
                    </div>

                </DialogTitle>}

            {(agentsList.length > 0 || checkLogin) &&
                <ul className="list-group">
                    {agentsList.map((m) =>
                        <li
                            style={{
                                position: 'relative',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0.5rem 1rem',
                                color: '#212529',
                                textDecoration: 'none',
                                backgroundColor: '#fff',
                                border: '1px solid rgba(0, 0, 0, 0.125)',
                            }}
                        // <li className={HomeStyles.menuList}
                        //  style={{
                        //     color: profile === m ? 'white' : '',
                        //     backgroundColor: profile === m ? '#3364AF' : ''
                        // }} 
                        >
                            <Typography>({m.AgentNumber ? m.AgentNumber : 'รออนุมัติ'}) {m.ContactName}</Typography>
                            <Button variant="contained" type="submit" onClick={() => onSave(m)} className={classes.button}
                            >
                                {spinner ?
                                    <div className="spinner-border spinner-border-sm" role="status"    >
                                        <span className="sr-only"></span>
                                    </div>
                                    : ('เลือก')

                                }
                            </Button>
                        </li>
                    )}
                </ul>

            }

            {errMessage && agentsList.length > 0 ?
                <Typography style={{
                    fontSize: '14px',
                    marginTop: '7px',
                    color: 'red',
                    textAlign: 'center'
                }}>
                    {errMessage}
                </Typography> : ''
            }

            {(agentsList.length > 0 || checkLogin) &&
                <DialogActions style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '20px',
                    marginBottom: '20px'

                }}>
                    {/* <Button variant="contained" type="submit" onClick={onBack} className={classes.buttonBack}
                    >
                        กลับ


                    </Button> */}
                    {/* <Button variant="contained" type="submit" onClick={onSave} className={classes.buttonSubmit} color="primary"
                    >
                        {spinner ?
                            <div className="spinner-border" role="status"    >
                                <span className="sr-only"></span>
                            </div>
                            : ('ยืนยัน')

                        }


                    </Button> */}
                </DialogActions>
            }
        </Dialog>

    );
}